// trendlineEngineOverlay.js
// Chart integration for the NEW trend line engine (trendlineEngine.js).
// Parallel to trendLineOverlay.js. No React, no store.
//
// ChartNew.jsx touch points (search "TREND LINE ENGINE"):
//   1. import this file
//   2. initTrendlineEngineSeries(chart, LineSeries)          — INIT CHART
//   3. drawTrendlineEngine(ref, cache, show, n, statesRef)   — next to each draw
//   4. applyTrendlineEngineVisibility(ref, cache, show, n, statesRef) — toggle useEffect
// ============================================================

import { computeTrendline } from './trendlineEngine';

const ENGINE_LINE_STYLE = {
  color:            '#2962FF',   // blue — new engine
  lineWidth:        2,
  priceLineVisible: false,
  lastValueVisible: false,
  crosshairMarkerVisible: false,
};

export function initTrendlineEngineSeries(chart, LineSeries) {
  return chart.addSeries(LineSeries, { ...ENGINE_LINE_STYLE, visible: false });
}

// DRAW. If statesRef is passed, fills statesRef.current with a Map(time -> state)
// so the legend can look up state/SL/action at the hovered candle.
export function drawTrendlineEngine(seriesRef, ohlcvCache, show, n = 3, statesRef = null) {
  if (!seriesRef.current) return;
  if (!ohlcvCache || ohlcvCache.length < 2) return;
  if (!show) return;

  const { states, linePoints } = computeTrendline(ohlcvCache, n);

  if (statesRef) {
    const m = new Map();
    for (const st of states) m.set(st.time, st);
    statesRef.current = m;
  }

  if (linePoints.length === 0) return;
  seriesRef.current.setData(linePoints);
}

export function applyTrendlineEngineVisibility(seriesRef, ohlcvCache, show, n = 3, statesRef = null) {
  if (!seriesRef.current) return;
  if (show) {
    drawTrendlineEngine(seriesRef, ohlcvCache, true, n, statesRef);
    seriesRef.current.applyOptions({ visible: true });
  } else {
    seriesRef.current.applyOptions({ visible: false });
  }
}

// ── TEMP DEBUG: dump engine output as CSV (call window.dumpEngine()) ──
export function dumpEngineCSV(ohlcvCache, n = 3) {
  const { states } = computeTrendline(ohlcvCache, n);
  const fmt = t => (t == null ? '' : new Date(t * 1000).toISOString().slice(0, 10));
  const header = 'date,open,high,low,close,state,sl_level,sl_date,range_high,range_low,committed_SL,action';
  const rows = states.map((s, i) => {
    const c = ohlcvCache[i];
    return [fmt(c.time), c.open, c.high, c.low, c.close,
            s.state, s.sl_level ?? '', fmt(s.sl_time),
            s.range_high ?? '', s.range_low ?? '', s.committed_SL ?? '', s.action].join(',');
  });
  const csv = [header, ...rows].join('\n');
  const blob = new Blob([csv], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = 'engine_dump.csv'; a.click();
  URL.revokeObjectURL(url);
}